import { QuestionSendType } from "../stores/appContext";
import { client, DEFAULT_HEADERS } from "./defaultClient";
import { Answerer } from "./generated";

export const getAnswerers = async (): Promise<Answerer[]> =>
    await client.getUsersMeAnswerers({ mode: "cors" });

export const getAnswerer = async (answererId: string): Promise<Answerer> =>
    await client.getUsersMeAnswerersAnswererId(
        { answererId },
        { mode: "cors" }
    );

export const createAnswerer = async (
    name: string,
    receiverNickname: string,
    questionSendType: QuestionSendType,
    email: string,
    birthday: string | undefined,
    relationship: string,
    qmailFrequency: string[],
    csrfToken: string
) => {
    return await client.postUsersMeAnswerers(
        {
            newAnswerer: {
                name: name,
                receiverNickname: receiverNickname,
                email: email,
                birthday,
                relationship: relationship,
                qmailFrequency: qmailFrequency,
                questionSendType: questionSendType,
            },
        },
        {
            mode: "cors",
            headers: {
                ...DEFAULT_HEADERS,
                "X-CSRF-Token": csrfToken,
            },
        }
    );
};

export const updateAnswerer = async (
    answererId: string,
    name: string,
    receiverNickname: string,
    email: string,
    birthday: string | undefined,
    relationship: string,
    questionSendType: string,
    qmailFrequency: string[],
    csrfToken: string
) => {
    return await client.patchUsersMeAnswerersAnswererId(
        {
            answererId: answererId,
            patchUsersMeAnswerersAnswererIdRequest: {
                name: name,
                receiverNickname: receiverNickname,
                email: email,
                birthday: birthday ?? undefined,
                relationship: relationship,
                questionSendType,
                qmailFrequency: qmailFrequency,
            },
        },
        {
            mode: "cors",
            headers: {
                ...DEFAULT_HEADERS,
                "X-CSRF-Token": csrfToken,
            },
        }
    );
};

export const sendVerifyEmailToAnswerer = async (
    answererId: string,
    csrfToken: string
) => {
    return await client.postUsersMeAnswerersAnswererIdVerifyEmail(
        {
            answererId,
        },
        {
            mode: "cors",
            headers: {
                ...DEFAULT_HEADERS,
                "X-CSRF-Token": csrfToken,
            },
        }
    );
};

export const uploadProfileImage = async (
    answererId: string,
    file: File,
    csrfToken: string
): Promise<string> => {
    const response = await client.postUsersMeAnswererUploadProfileImage(
        {
            answererProfileImage: file,
            answererId: answererId,
        },
        {
            mode: "cors",
            headers: {
                "X-CSRF-Token": csrfToken,
            },
        }
    );
    return response.filePath ?? "";
};
